(function () {
	function featuredCollectionSlider() {
		const sliders = document.querySelectorAll(".collection-slider");

		if (sliders.length) {
			sliders.forEach(slider => {
				const id = slider.dataset.sectionId,
					centeredSlide = (slider.dataset.centeredSlide == 'true'),
					columnsMobile = slider.dataset.columnsMobile ? slider.dataset.columnsMobile : 1,
					columnsDesktop = slider.dataset.columnsDesktop ? slider.dataset.columnsDesktop : 2;

				let tabletSlides = 2;
				let proTabletSlides = 2;
				initialSlide = 0;
				if(centeredSlide == true) {
					tabletSlides = 2.4;
					proTabletSlides = 2.8;
					initialSlide = 1;
				}

				const swiperfeaturedCollectionSlider = new Swiper(`.collection-slider-${id}`, {
					loop: true,
					centeredSlides: true,
					initialSlide: initialSlide,
					slidesPerView: columnsMobile,
					slideToClickedSlide: false,
					spaceBetween: 20,
					grabCursor: true,
					longSwipesMs: 500,
					longSwipesRatio: 1,
					navigation: {
						nextEl: `.collection-slider-${id} .slider-arrow-next`,
						prevEl: `.collection-slider-${id} .slider-arrow-prev`,
					},
					breakpoints: {
						750: {
							loop: false,
							centeredSlides: centeredSlide,
							slidesPerView: tabletSlides
						},
						990: {
							centeredSlides: centeredSlide,
							slidesPerView: proTabletSlides
						},
						1099: {
							loop: true,
							initialSlide: 0,
							centeredSlides: centeredSlide,
							slidesPerView: columnsDesktop,
							spaceBetween: 30
						}
					}
				});
			});
		}
	}

	document.addEventListener('DOMContentLoaded', featuredCollectionSlider);
	document.addEventListener('shopify:section:load', featuredCollectionSlider);
	window.addEventListener('resize', featuredCollectionSlider);
})();